import { useEffect, useState } from 'react';
import { Button, Col, Form, Row } from 'antd';
import { useNavigate } from 'react-router-dom';
import useStore from '../../../store';
import { LoginRequest } from '../../../request/AuthRequest';
import { Notification } from '../../../config/Global';
import InputComponent from '../../../component/InputComponent';

const LoginForm = () => {
	const [form] = Form.useForm();
	const [saving, setSaving] = useState(false);
	const { AUTH } = useStore();
	const { doLogin, remember_me } = AUTH;

	const handleSubmit = (data) => {
		setSaving(true);
		if (data.remember) {
			let encryptCred = JSON.stringify({
				email: data.username,
				password: data.password,
			});
			localStorage.setItem('remember_me', window.btoa(encryptCred));
		} else {
			window.localStorage.removeItem('remember_me');
		}
		delete data.remember;
		doLogin(data)
			.then((data) => {
				if (data.httpStatusCode === 401) {
					Notification.error({ message: data.message });
					form.resetFields();
				} else {
					Notification.success({ message: LoginRequest.success });
				}
				// navigate('/dashboard');
			})
			.catch((e) => {
				Notification.error({ message: e.data });
				setSaving(false);
			})
			.finally(() => setSaving(false));
	};

	useEffect(() => {
		if (window.localStorage.getItem('remember_me')) {
			const decryptData = JSON.parse(
				window.atob(window.localStorage.getItem('remember_me'))
			);
			form.setFieldsValue({
				username: decryptData.email,
				password: decryptData.password,
				remember: true,
			});
		}
	}, [remember_me, form]);

	return (
		<div className="bg-img">
			<div className="loginForm">
				<Row gutter={24}>
					{/* <Col span={12}>
					<div className="loginBG">
						<img
							src={loginImage}
							className="loginBG"
							alt="loginImage"
						/>
					</div>
				</Col> */}
					<Col span={24}>
						<div className="loginFormWrap">
							<div className="formTitle">
								<h1>Booking Dham</h1>
							</div>
							<Form
								form={form}
								onFinish={handleSubmit}
								layout="vertical"
							>
								<InputComponent
									name="userName"
									label="Username"
									placeholder="Enter Username"
									rules={LoginRequest.userName}
								/>
								<InputComponent
									type="password"
									name="password"
									label="Password"
									placeholder="xxxxxxx"
									rules={LoginRequest.password}
								/>
								<Form.Item className="remember_forgot_wrap">
									<InputComponent
										hasFeedback
										type="checkbox"
										name="remember"
										label="Remember me"
										valuePropName="checked"
									/>
									{/* <Link
										to="/forgot-password"
										type="link"
										className="forgot_pass_link login-form-forgot"
									>
										Forgot password?
									</Link> */}
								</Form.Item>
								<Button
									loading={saving}
									type="primary"
									htmlType="submit"
								>
									Login
								</Button>
							</Form>
						</div>
					</Col>
				</Row>
			</div>
		</div>
	);
};

export default LoginForm;
